import { Injectable } from '@angular/core'
import { ODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export interface IClaimExportConfig extends IModelBase {
  ClaimTypeId: string
  ClaimExportTypeId: string
  PayerId: string
  JVName: string
}

@Injectable()
export class ClaimExportConfigODataService extends ODataService<IClaimExportConfig> {
  constructor(
    protected http: HttpClient,
    protected config: ODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'ClaimExportConfigs'
  }
}
